function LargeAccountIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 50 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect y={0.279} width={14.341} height={14.341} rx={1.646} fill="#22C55E" />
      <rect
        x={17.829}
        y={0.279}
        width={14.341}
        height={14.341}
        rx={1.646}
        fill="#22C55E"
      />
      <rect
        x={35.659}
        y={0.279}
        width={14.341}
        height={14.341}
        rx={1.646}
        fill="#22C55E"
      />
    </svg>
  )
}

export default LargeAccountIcon
